module.exports = __webpack_public_path__ + "fa-brands-400.b8f15b3131082831d10b.svg";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/Exchange-NewsAdmin-Frontend/src/assets/fonts/webfonts/fa-brands-400.svg
// module id = ../../../../../src/assets/fonts/webfonts/fa-brands-400.svg
// module chunks = styles